import React, { useState, useEffect } from "react";
import { toast } from "../../../../components/toastNotification";
import TextInput from "../../../../components/TextInput";
import Button from "../../../../components/Button";
import {
  CheckCircleIcon,
  PencilSquareIcon,
  XCircleIcon,
} from "@heroicons/react/24/solid";
import { useRecoilState } from "recoil";
import ConfirmBoxModal from "../../../../components/ConfirmBoxModal";
import EmployeeTypeForm from "./EmployeeTypeForm";
import AddButton from "../../../../components/AddButton";
import ConfirmBoxDelete from "../../../../components/ConfirmBoxDelete";

import useEmployeeType from "./hooks/useEmployeeType";
import useDeleteEmployeeType from "./hooks/useDeleteEmployeeTypes";
import useUpdateEmployeeType from "./hooks/useUpdateEmployeeType";
import {
  addStateEmployeeType,
  selectedRowsStateEmployeeType,
  setFilterTextEmployeeType,
} from "./atoms/atoms";
import TableFilters from "../TableFilters";
import { permissionsSelector } from "../../../Login/selectors/permissionSelector";
import { useRecoilValue } from "recoil";
import { PERMISSIONS } from "../../../PermissionsConstants";
import { accountAtom } from "../../../Login/atoms/AccountAtom";
import { notificationFilterById } from "../../../../actions/Utilities/NotificationFilter";
import { useHistory, useLocation } from "react-router-dom";
import MaterialEmployeeConfigTable from "../../../../components/tables/MaterialEmployeeConfigTable";
import EditButton from "../../../../components/EditButton";

const EmployeeTypeTable = () => {
  //Hooks Call
  const { data, isFetching } = useEmployeeType();
  const UpdateEmployeeType = useUpdateEmployeeType();
  const BulkDeleteEmploymentType = useDeleteEmployeeType();
  //Atoms Call
  const [actionAddState, setActionAddState] =
    useRecoilState(addStateEmployeeType);
  const [selectedRows, setSelectedRows] = useRecoilState(
    selectedRowsStateEmployeeType
  );
  const [filterText, setFilterText] = useRecoilState(setFilterTextEmployeeType);
  //Local States
  const [rowsCount, setRowsCount] = useState(0);
  const [editRowId, setEditRowId] = useState(null);
  const [actionEditState, setActionEditState] = useState(false);
  const [empTypeIsExist, setEmpTypeIsExistState] = useState(false);
  const [empTypeDataIsChange, setEmpTypeDataIsChange] = useState(false);
  const [checkStatus, setCheckStatus] = useState(false);
  const [checkMexico, setCheckMexico] = useState(false);
  const [openModalDelete, setOpenModalDelete] = useState(false);
  const [openModalEdit, setOpenModalEdit] = useState(false);
  const [hasEmployeeType, setHasEmployeeType] = useState(true);
  const [isBulkSelected, setIsBulkSelected] = useState(false);
  const [disabledButton, setDisabledButton] = useState(false);
  const [displayNote] = useState(false);
  const [edit, setEdit] = useState(false);
  const [hideColumn, sethideColumn] = useState(false);
  const userAccount = useRecoilState(accountAtom);
  const [employeeTypeFilteredData, setEmployeeTypeFilteredData] = useState([]);

  const defaultValues = {
    employeeTypeId: 0,
    employeeTypeName: "",
    createdBy: "",
    createdDate: null,
    modifiedBy: null,
    modifiedDate: null,
    isActive: 0,
    usedInMexico: false,
  };

  const editPermission =
    PERMISSIONS.permission_utilities_employeetype_employeetype_edit;
  const addPermission =
    PERMISSIONS.permission_utilities_employeetype_employeetype_add;
  const deletePermission =
    PERMISSIONS.permission_utilities_employeetype_employeetype_delete;

  const userPermissions = useRecoilValue(permissionsSelector);
  const [empNewData] = useState([defaultValues]);
  let location = useLocation();
  const history = useHistory();
  let recordIdFromRecent = "";
  if (location.state != null) {
    recordIdFromRecent = location.state;
  }

  //For filtered data update
  const [empTypeId, setEmpTypeId] = useState("");
  useEffect(() => {
    if (empTypeId?.includes(".")) {
      let empTypeIds = empTypeId.split(".");
      const empTypeIdsArr = empTypeIds.map((id) => Number(id));
      const filteredData = data?.filter((x) =>
        empTypeIdsArr.includes(x.employeeTypeId)
      );
      setEmployeeTypeFilteredData(filteredData);
    } else {
      const filteredData = data?.filter(
        (x) => x.employeeTypeId === Number(empTypeId)
      );
      setEmployeeTypeFilteredData(filteredData);
    }
  }, [empTypeId, data]);

  useEffect(() => {
    if (recordIdFromRecent !== "") {
      try {
        notificationFilterById(
          recordIdFromRecent.recordId,
          recordIdFromRecent.moduleName,
          recordIdFromRecent.subModuleName
        ).then((result) => {
          setEmployeeTypeFilteredData(result);
          setEmpTypeId(recordIdFromRecent.recordId);
          history.replace();
        });
      } catch (error) { }
    } else {
      localStorage.removeItem("NotifFilter");
      localStorage.removeItem("ModuleFilter");
    }
  }, []);

  useEffect(() => {
    setEmpTypeIsExistState(false);
    setEmpTypeDataIsChange(false);
    setActionAddState(false);
    setActionEditState(false);
    setSelectedRows([]);
    setEditRowId([]);
    setFilterText("");
  }, []);

  const handleSelectedRowsChange = (rows) => {
    const forDelete = rows.filter((x) => x.isActive);
    setSelectedRows(forDelete);
    setRowsCount(forDelete.length);
    setIsBulkSelected((prev) => !prev);
  };

  const handleCheckBox = (checked, field, rowData) => {
    if (field === "isActive") {
      checked ? setCheckStatus(true) : setCheckStatus(false);
      checked
        ? empNewData.map((x) => (x.isActive = true))
        : empNewData.map((x) => (x.isActive = false));
    }
    else if (field === "isMexico") {
      checked ? setCheckMexico(true) : setCheckMexico(false);
      checked
        ? empNewData.map((x) => (x.usedInMexico = true))
        : empNewData.map((x) => (x.usedInMexico = false));
    }

    setEmpTypeDataIsChange(
      rowData.employeeTypeName !== empNewData[0].employeeTypeName.trim() ||
      rowData.isActive !== empNewData[0].isActive ||
      (rowData.usedInMexico === true) !== empNewData[0].usedInMexico
    );
  };

  const handleEditFieldsChange = (SourceType, fieldName, row, inputvalue) => {
    setEmpTypeIsExistState(false);
    setEmpTypeDataIsChange(false);
    inputvalue = inputvalue.trim();

    if (SourceType === "employeeType") {
      if (fieldName === "EmployeeTypeName") {
        const result = data.filter(
          (item) => {
            if (item.employeeTypeId !== row.employeeTypeId &&
              item.employeeTypeName?.toUpperCase() === inputvalue?.toUpperCase()) {
              return true;
            }
          }
        )[0];

        result !== undefined
          ? setEmpTypeIsExistState(true)
          : empNewData.map((x) => (x.employeeTypeName = inputvalue));
      }

      inputvalue === "" ? setHasEmployeeType(false) : setHasEmployeeType(true);

      setEmpTypeDataIsChange(
        row.employeeTypeName !== inputvalue ||
        row.isActive !== empNewData[0].isActive ||
        (row.usedInMexico === true) !== empNewData[0].usedInMexico
      );
    }
  };

  const handleEditButton = (rowData) => {
    setEditRowId(rowData.employeeTypeId);
    setEmpTypeDataIsChange(false);
    setEdit(true);
    setCheckStatus(rowData.isActive);
    setCheckMexico(rowData.usedInMexico);
    sethideColumn(true);
    empNewData.map((x) => (x.isActive = rowData.isActive));
    empNewData.map((x) => (x.employeeTypeId = rowData.employeeTypeId));
    empNewData.map((x) => (x.employeeTypeName = rowData.employeeTypeName));
    empNewData.map((x) => (x.createdDate = rowData.createdDate));
    empNewData.map((x) => (x.createdBy = rowData.createdBy));
    empNewData.map((x) => (x.modifiedBy = userAccount[0].username));
    empNewData.map((x) => (x.usedInMexico = rowData.usedInMexico === true));
  };

  //Save changes
  const handleSave = (empNewData) => {
    if (empTypeDataIsChange) {
      if (!empTypeIsExist) {
        if (empNewData.filter((x) => x.employeeTypeName) !== "") {
          UpdateEmployeeType(empNewData);
          setEditRowId([]);
          setSelectedRows([]);
          setEmpTypeIsExistState(false);
          setEmpTypeDataIsChange(false);
          setOpenModalEdit(false);
          setActionEditState(false);
          setDisabledButton(false);
          setEdit(false);
          sethideColumn(false);
        } else {
          toast.fire(
            "Saving Failed",
            "All required fields must be filled!",
            "error"
          );
          setOpenModalEdit(false);
        }
      } else {
        toast.fire("Saving Failed", "Employee Type already exists!", "error");
        setOpenModalEdit(false);
      }
    } else {
      toast.fire("Saving Failed", "No Changes have been made", "warning");
      setEditRowId([]);
      setOpenModalEdit(false);
      setEmpTypeDataIsChange(false);
      setActionEditState(false);
      setDisabledButton(false);
      setEdit(false);
    }
  };
  // end of saving changes

  const handleBulkDelete = () => {
    const ids = selectedRows.map((row) => row.employeeTypeId);
    BulkDeleteEmploymentType(ids);
    setSelectedRows([]);
    setOpenModalDelete(false);
    setIsBulkSelected(false);
  };

  const deleteMessage = (
    <div className="text-gray-500 font-normal">{`Are you sure you want to deactivate ${rowsCount} ${rowsCount > 1 ? "Employee Types" : "Employee Type"
      }?`}</div>
  );

  const matColumns = [
    {
      title: "Employee Type Name",
      field: "employeeTypeName",
      customSort: (a, b) =>
        a.employeeTypeName && b.employeeTypeName
          ? a.employeeTypeName.trim().localeCompare(b.employeeTypeName.trim())
          : a.employeeTypeName
            ? 0
            : -1,
      render: (rowData) => {
        return rowData.employeeTypeId === editRowId ? (
          <div className="flex items-center space-x-1 cursor-pointer">
            <TextInput
              placeholder="Employee Type"
              defaultValue={rowData.employeeTypeName}
              onChange={(inputdata) => {
                handleEditFieldsChange(
                  "employeeType",
                  "EmployeeTypeName",
                  rowData,
                  inputdata.target.value
                );
              }}
            />
          </div>
        ) : (
          <span className="text-quinary font-bold uppercase text-sm">
            {rowData.employeeTypeName}
          </span>
        );
      },
    },
    {
      title: "Is Mexico",
      field: "UsedInMexico",
      customSort: (a, b) => {
        const valA = a.usedInMexico ? 1 : 0;
        const valB = b.usedInMexico ? 1 : 0;
        return valA - valB;
      },
      render: (rowData) => {
        return rowData.employeeTypeId === editRowId ? (
          <div className="flex justify-start place-items-center space-x-1 cursor-pointer">
            <input
              type="checkbox"
              className="flex items-center space-x-1 cursor-pointer mt-0.5"
              defaultChecked={rowData.usedInMexico === true}
              onClick={(e) => {
                handleCheckBox(e.target.checked, "isMexico", rowData);
              }}
            />
            <label className="cursor-pointer text-green-600" name="Mexico">
              {checkMexico ? "Uncheck if U.S." : "Check if Mexico"}
            </label>
          </div>
        ) : (
          <div>
            <div className="font-sans text-left mr-4 text-xs">
              {rowData.usedInMexico ? "Yes" : "No"}
            </div>
          </div>
        );
      }
    },
    {
      title: "Created By",
      field: "createdBy",
      hidden: hideColumn,
      customSort: (a, b) =>
        a.createdBy && b.createdBy
          ? a.createdBy.trim().localeCompare(b.createdBy.trim())
          : a.createdBy
            ? 0
            : -1,

      render: (rowData) => {
        return rowData.employmentTypeId === editRowId ? (
          <div className="flex items-center space-x-1 cursor-pointer"></div>
        ) : (
          <>{rowData.createdBy}</>
        );
      },
    },
    {
      title: "Created Date",
      field: "createdDate",
      hidden: hideColumn,
      render: (rowData) => {
        return rowData.employmentTypeId === editRowId ? (
          <div className="flex items-center space-x-1 cursor-pointer"></div>
        ) : (
          <>{new Date(rowData.createdDate).toLocaleDateString()}</>
        );
      },
    },
    {
      title: "Modified By",
      field: "modifiedBy",
      hidden: hideColumn,
      customSort: (a, b) =>
        a.modifiedBy && b.modifiedBy
          ? a.modifiedBy.trim().localeCompare(b.modifiedBy.trim())
          : a.modifiedBy
            ? 0
            : -1,
      render: (rowData) => {
        return rowData.employeeTypeId === editRowId ? (
          <div className="flex items-center space-x-1 cursor-pointer"></div>
        ) : (
          <>{rowData.modifiedBy}</>
        );
      },
    },
    {
      title: "Modified Date",
      field: "modifiedDate",
      hidden: hideColumn,
      render: (rowData) => {
        return rowData.employeeTypeId === editRowId ? (
          <div className="flex items-center space-x-1 cursor-pointer"></div>
        ) : (
          <>
            {rowData.modifiedDate
              ? rowData.modifiedDate &&
              new Date(rowData.modifiedDate).toLocaleDateString()
              : ""}
          </>
        );
      },
    },
    {
      title: "Status",
      field: "isActive",
      align: "left",
      render: (rowData) => {
        return rowData.employeeTypeId === editRowId ? (
          <div className="flex justify-start space-x-1 cursor-pointer">
            <input
              type="checkbox"
              className="flex items-center space-x-1 cursor-pointer mt-0.5"
              defaultChecked={rowData.isActive}
              onClick={(e) => {
                handleCheckBox(e.target.checked, "isActive", rowData);
              }}
            />
            <label
              className="items-center cursor-pointer text-green-600 text-xs"
              name="Status"
            >
              {checkStatus ? "Uncheck to Deactivate" : "Check to Activate"}
            </label>
          </div>
        ) : (
          <div>
            <div className="font-sans text-left mr-4 text-xs">
              {rowData.isActive ? "Active" : "Inactive"}
            </div>
          </div>
        );
      },
    },
    {
      title: "Action/s",
      align: "center",
      render: (rowData) => {
        return !userPermissions.includes(editPermission) ? (
          ""
        ) : rowData.employeeTypeId === editRowId ? (
          <div className="flex justify-center space-x-2 w-full mr-2">
            <Button
              className={`flex items-center shadow-md text-xs font-semibold text-white  gap-x-1 rounded-full  bg-senary hover:bg-senary px-3 py-1 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-senary focus:ring-opacity-70
            ${!hasEmployeeType || !empTypeDataIsChange
                  ? "opacity-50"
                  : "opactiy-100"
                }`}
              disabled={!hasEmployeeType || !empTypeDataIsChange}
              onClickFunction={() => {
                setOpenModalEdit(true);
              }}
            >
              <CheckCircleIcon className="h-4 w-4 " />
              <div className="text-xs3 font-normal self-center -mt-px">
                Save
              </div>
            </Button>
            <Button
              className="flex items-center text-xs shadow-md font-semibold text-white ml-1 gap-x-1 rounded-full bg-octonary hover:bg-octonary px-2 py-1 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-octonary focus:ring-opacity-70"
              onClickFunction={() => {
                setActionEditState(false);
                setEditRowId([]);
                setEmpTypeDataIsChange(false);
                setEmpTypeIsExistState(false);
                setDisabledButton(false);
                setEdit(false);
                sethideColumn(false);
              }}
            >
              <XCircleIcon className="h-4 w-4" />
              <div className="text-xs3 font-normal self-center -mt-px">
                Cancel
              </div>
            </Button>
          </div>
        ) : (
          <div className="flex items-center place-content-center mr-5">
            <EditButton
              disabled={disabledButton || selectedRows.length > 0}
              className={
                disabledButton || selectedRows.length > 0
                  ? "opacity-50 rounded-full space-x-2 items-center bg-quaternary  text-white hover:bg-hquaternary "
                  : "opacity-100 rounded-full space-x-2 items-center bg-quaternary  text-white hover:bg-hquaternary"
              }
              onClick={() => {
                setDisabledButton(true);
                setActionEditState(true);
                handleEditButton(rowData);
              }}
            >
              <PencilSquareIcon className="h-4 w-4 -mr-2" />
              <div className="text-xs3 font-normal">Edit</div>
            </EditButton>
          </div>
        );
      },
    },
  ];

  //Filters
  const filteredItems = data
    ? data.filter(
      (item) =>
        item.employeeTypeName &&
        item.employeeTypeName
          .toLowerCase()
          .includes(filterText.trim().toLowerCase())
    )
    : [];

  useEffect(() => {
    if (filterText.trim() == "") setEmployeeTypeFilteredData([]);
  }, [filterText]);

  return (
    <div className="animate-fade-in-down bg-white p-4">
      {!actionAddState && (
        <>
          <div className="flex justify-between text-xs items-center w-full">
            <TableFilters
              filterText={setFilterText}
              moduleDetails="Employee Type Name"
              textInputName="EmployeeTypeName"
              columnDetails={"Employee Type Name"}
              disabledButton={disabledButton || selectedRows.length > 0}
            ></TableFilters>

            <div className="">
              {userPermissions.includes(addPermission) ? (
                <AddButton
                  buttonText="New Employee Type"
                  className={
                    selectedRows.length > 0 || actionEditState
                      ? "opacity-50 self-center -mt-px"
                      : "opacity-100  self-center -mt-px"
                  }
                  onClick={() => setActionAddState(!actionAddState)}
                  disabled={disabledButton || selectedRows.length > 0}
                />
              ) : (
                ""
              )}
            </div>
          </div>
          <div>
            {userPermissions.includes(deletePermission) ? (
              <div className="text-secondary italic text-xs3 my-2">
                <p className="font-bold italic inline-block mr-1">Note:</p>
                <span>Tick the box to deactivate some data.</span>
              </div>
            ) : (
              <div className="mb-4"></div>
            )}
          </div>

          <div className="overflow-y-auto ">
            <MaterialEmployeeConfigTable
              columns={matColumns}
              data={
                employeeTypeFilteredData?.length > 0
                  ? employeeTypeFilteredData
                  : data
                    ? filterText === ""
                      ? data
                      : filteredItems
                    : []
              }
              options={{
                toolbar: false,
                showTitle: false,
              }}
              selection={
                !actionEditState && userPermissions.includes(deletePermission)
              }
              setOpenModal={setOpenModalDelete}
              onSelectionChange={handleSelectedRowsChange}
              selectedRows={selectedRows}
              isDeactivate={true}
              isLoading={isFetching}
            />
          </div>

          <ConfirmBoxModal
            ModalTitle="Update Employee Type"
            qConfirmation=" Are you sure you want to update this?"
            isOpen={openModalEdit}
            onClose={() => setOpenModalEdit(false)}
            onClickFunction={() => {
              handleSave(empNewData);
            }}
          />
          <ConfirmBoxDelete
            ModalTitle="Deactivate Employee Type"
            qConfirmation={deleteMessage}
            isOpen={openModalDelete}
            onClose={() => setOpenModalDelete(false)}
            onClickFunction={
              isBulkSelected ? handleBulkDelete : handleBulkDelete
            }
          />
        </>
      )}
      {actionAddState && (
        <div className="">
          <EmployeeTypeForm />
        </div>
      )}
    </div>
  );
};

export default EmployeeTypeTable;
